import modalLayout from '../../styles/modalLayout'

const styles = {
  ...modalLayout,
  headerLabel: {
    marginBottom: 3,
  },
  sectionLabel: {
    marginTop: 3,
    marginBottom: 2,
  },
  serialRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    marginBottom: 3,
  },
  serialValue: {
    fontWeight: 500,
    letterSpacing: 1,
  },
  statRow: {
    display: 'flex',
    gap: 5,
    marginBottom: 3,
    flexWrap: 'wrap',
  },
  statTile: {
    minWidth: 140,
  },
  statTileValue: {
    fontWeight: 500,
  },
  statTileLabel: {
    color: 'text.secondary',
  },
  actionsRow: {
    display: 'flex',
    gap: 2,
    marginBottom: 3,
  },
  actionButtonProgress: {
    marginLeft: 1,
    color: 'inherit',
  },
  refetchErrorBanner: {
    marginBottom: 3,
  },
  transitionErrorBanner: {
    marginBottom: 3,
  },
  transitionDialogField: {
    marginTop: 2,
  },
  transitionDialogError: {
    marginBottom: 2,
  },
  transitionDialogActions: {
    padding: 3,
    paddingTop: 0,
  },
  timelineEntry: {
    display: 'flex',
    gap: 2,
  },
  timelineRail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 12,
    flexShrink: 0,
  },
  timelineDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    flexShrink: 0,
    marginTop: '4px',
  },
  timelineLine: {
    width: '2px',
    flex: 1,
    minHeight: 24,
    backgroundColor: 'divider',
    marginTop: '4px',
  },
  timelineContent: {
    paddingBottom: 3,
  },
  timelineDate: {
    color: 'text.secondary',
  },
  timelineDescription: {
    fontWeight: 500,
  },
  buttonContainer: {
    textAlign: 'right',
    paddingTop: 3,
  },
}
export default styles
